import { Card, Flex, Separator, Text, SubTitle, CSSFn } from "@shared/primitive-components"
import * as styles from "./infoPaneStyles"

export type InfoPaneProps = Readonly<{
  title: string
  summary: ReadonlyArray<string>
  children: React.ReactNode
  css?: CSSFn
}>

export const InfoPane = (props: InfoPaneProps) => {
  const { css, title, summary, children } = props
  return (
    <Card css={styles.makeRootStyle(css)}>
      <SubTitle>{title}</SubTitle>

      <Separator size="block" color="yellow" css={styles.separator} />

      {summary.length > 0 && (
        <Flex flexDirection="column" css={styles.summary}>
          {summary.map((text, idx) => (
            <Text key={idx}>{text}</Text>
          ))}
        </Flex>
      )}

      {children}
    </Card>
  )
}
